import BaseEntity from '../../base/BaseEntity.model';
import Direccion from '@/models/direccion.model';

export default class SolicitudActualizacionElegibleModel extends BaseEntity {
    public tramiteBeneficiarioId?: number;
    public cambioJefeHogar?: boolean = false;
    public cambioDireccion?: boolean = false;
    public actualizacionNuevoMiembro?: boolean = false;
    public actualizarCaracteristicaVivienda?: boolean = false;
    public actualizarICV?: boolean = false;
    public jefeHogarId?: number;
    public direccion?: Direccion;
    constructor(public direccionId: number | undefined = undefined) {
        super();
        this.tramiteBeneficiarioId = undefined;
        this.jefeHogarId = undefined;
        this.direccion = undefined;
    }
}